import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledValues } from './styles';
import { Slider } from '../Slider';
import { Text } from '../Text';
export var RiskLevelSlider = function (_a) {
  var label = _a.label,
    min = _a.min,
    max = _a.max,
    value = _a.value,
    onChange = _a.onChange,
    onAfterChange = _a.onAfterChange;
  return _jsxs("div", {
    style: {
      width: '100%'
    },
    "data-cy-label": "risk-level-slider",
    children: [_jsxs(StyledValues, {
      children: [_jsx(Text, {
        el: "span",
        styleName: "label",
        children: label
      }), _jsxs("div", {
        children: [_jsx(Text, {
          el: "span",
          styleName: "title4",
          children: value
        }), _jsx(Text, {
          el: "span",
          styleName: "title7",
          children: _jsxs(_Fragment, {
            children: ["/", max]
          })
        })]
      })]
    }), _jsx(Slider, {
      min: min,
      max: max,
      value: value,
      onChange: onChange ? onChange : undefined,
      onAfterChange: onAfterChange ? onAfterChange : undefined
    })]
  });
};